import * as React from 'react'
import * as styles from './style/index.scss'
import {Button} from 'antd-mobile'
import {FormattedMessage} from 'react-intl'
import CloseImg from '@assets/img/del_bullet_box.png'
import SuccessImg from '@assets/img/global/success.png'

interface ActiveSuccessProps {
    handleClose: () => void
}

class ActiveSuccess extends React.Component<ActiveSuccessProps> {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <section className={styles.maskWrap}>
                <div className={styles.innerWrap}>
                    <img src={CloseImg} className={styles.closeImg} onClick={this.props.handleClose}/>
                    <div className={styles.iconWrap}>
                        <img src={SuccessImg}/>
                    </div>
                    <div className={styles.infoWrap}>
                        <p>
                            <FormattedMessage id="home.active.success"/>
                        </p>
                        <Button className={styles.btn} onClick={this.props.handleClose}>
                            <FormattedMessage id="home.active.success.btn"/>
                        </Button>
                    </div>
                </div>
            </section>
        )
    }
}

export default ActiveSuccess
